import { useCallback, useState } from "react"
import styles from "./Card.module.css"
import { useTranslation } from "react-i18next"

const Card = ({ children, style, onClick = () => { }, error = false, hover = false, title = "", tag = "", noPadding, appearance, actions, integratedTable = false }) => {
    const [_hover, setHover] = useState(false)
    const { t } = useTranslation()
    const enter = useCallback(() => {
        if (hover) {
            setHover(true)
        }
    }, [hover])

    const exit = useCallback(() => {
        setHover(false)
    }, [])

    return (
        <div
            onMouseEnter={enter}
            onMouseLeave={exit}
            className={`${styles.container} ${noPadding ? styles.noPadding : ""} ${appearance === "modern" ? styles.modern : ""} ${integratedTable ? styles.integratedTable : ""}`} style={{
                ...style,
                border: error ? "1px solid rgba(var(--sf-red-rgb), 80%)" :
                    _hover ? "1px solid var(--primary)" :
                        "1px solid rgba(var(--text-color-rgb), 12%)",
            }} onClick={onClick}>
            <div className={`${styles.content}`}>
                {appearance === "modern" && title && <div className={styles.modernHeader}><h2>{title}</h2>{actions}</div>}
                {
                    appearance !== "modern" && title && !tag &&
                    <div className={`${styles.title} ${_hover ? styles.hover : ""} ${noPadding ? styles.noPadding : ""}`}
                    >{title}</div>
                }
                {
                    appearance !== "modern" && title && tag &&
                    <div className={styles.titleWithTag}>
                        <div className={_hover ? `${styles.title} ${styles.hover}` : styles.title}>
                            {title}
                        </div>
                        <div className={styles.tag}>
                            {tag}
                        </div>
                    </div>
                }

                {children}
            </div>
        </div>
    )

}

export default Card
